export type UpdateComponentProjectRequest = {
  pjtId: string;
  updateDateTime: string;
  stupTaskCtgries: UpdateStupTaskCtgries[];
  stupTasks: UpdateStupTasks[];
  taskSelectionCompleteFlg: string;
};
export type UpdateStupTaskCtgries = {
  stupTaskCtgryId: string;
  necFlg: string;
  dsgnInfo: string;
};
export type UpdateStupTasks = {
  stupTaskCtgryId: string;
  stupTaskId: string;
  necFlg: string;
};
